import React, { Component } from 'react';
import classnames from 'classnames';
import LazyLoad from 'react-lazyload';

class ModelSerialCard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selected: 'model',
			showModelNumberOverlay: false
		};
	}

	selectModel() {
		this.setState({ selected: 'model' });
		global.dataLayer.push({
			event: 'Model - Serial Number',
			eventCategory: 'Find Your Model / Serial Number',
			eventAction: 'Model Number',
			eventLabel: this.props.data.name
		});
	}

	selectSerial() {
		this.setState({ selected: 'serial' });
		global.dataLayer.push({
			event: 'Model - Serial Number',
			eventCategory: 'Find Your Model / Serial Number',
			eventAction: 'Serial Number',
			eventLabel: this.props.data.name
		});
	}

	showModelNumberOverlay() {
		this.setState({ showModelNumberOverlay: true });
		global.dataLayer.push({
			event: 'Model - Serial Number',
			eventCategory: 'Find Your Model / Serial Number',
			eventAction: 'How to read model and serial number',
			eventLabel: this.props.data.name
		});
	}

	hideModelNumberOverlay() {
		this.setState({ showModelNumberOverlay: false });
	}

	render() {
		const {
			name,
			modelType,
			modelNo,
			modelNos,
			serialNo,
			modelNumberLocation,
			serialNumberLocation,
			seeMoreLink
		} = this.props.data;

		const modelThumb = require(`../../../resources/img/model-serial-number/${this.props.data.modelThumb}`);
		const seeMoreLinkImage = seeMoreLink ? require(`../../../resources/img/model-serial-number/${seeMoreLink.image}`) : null;

		const ModelNumberLocations = () => {
			const locations = [];
			if (modelNumberLocation !== undefined && modelNumberLocation.length) {
				for (let index = 0; index < modelNumberLocation.length; index++) {
					const y = modelNumberLocation[index].y;
					const x = modelNumberLocation[index].x;
					const tooltip = modelNumberLocation[index].tooltip;
					const styles = {
						display: this.state.selected === 'model' ? 'block' : 'none',
						left: `${x / 230 * 100}%`,
						top: `${y / 230 * 100}%`
					};
					locations.push(
						<div className="number-location" style={styles} key={index}>
							{
								tooltip !== '' ?
									(
										<span className="number-location-tooltip">
											{tooltip}
										</span>
									) : null
							}
						</div>
					);
				}
			}
			return <div>{locations}</div>;
		};

		let modelNumberList;

		if (modelNos && modelNos.length > 0) {
			const listValue = modelNos.map(
				(modelValue, index) => <li className='model-number-list-item'>{modelValue}</li>
			);

			modelNumberList =
				<div className="model-number-list">
					<div className='model-number-title'>Model Numbers</div>
					<ul >{listValue}</ul>
				</div>
		}

		const SerialNumberLocations = () => {
			const locations = [];
			if (serialNumberLocation !== undefined && serialNumberLocation.length) {
				for (let index = 0; index < serialNumberLocation.length; index++) {
					const y = serialNumberLocation[index].y;
					const x = serialNumberLocation[index].x;
					const tooltip = serialNumberLocation[index].tooltip;
					const styles = {
						display: this.state.selected === 'serial' ? 'block' : 'none',
						left: `${x / 230 * 100}%`,
						top: `${y / 230 * 100}%`
					};
					locations.push(
						<div className="number-location" style={styles} key={index}>
							{
								tooltip !== '' ?
									(
										<span className="number-location-tooltip">
											{tooltip}
										</span>
									) : null
							}
						</div>
					);
				}
			}
			return <div>{locations}</div>;
		};

		return (
			<div className="col sm-4" data-product-name={name}>
				<div className="model-serial-card">
					<h3 className="card-title">{name}</h3>
					<figure className="card-image">
						<LazyLoad once={true} offset={200}>
							<img
								src={modelThumb}
								alt={name}
								role="presentation"
							/>
						</LazyLoad>
						<ModelNumberLocations />
						<SerialNumberLocations />
					</figure>

					{
						modelType === 'modelOnly' ?
							(
								<div>
									{seeMoreLink &&

										<a
											className="arrow-link"
											href={seeMoreLinkImage}
											target="_blank"
										>
											{seeMoreLink.text}
										</a>
									}
									{modelNos && modelNos.length > 0 &&
										<a
											onClick={() => this.showModelNumberOverlay()}
											className="arrow-link"
										>
											How to read model and serial number
										</a>
									}
									{modelNos && modelNos.length > 0 &&
										<div
											className="model-number-overlay"
											data-visible={this.state.showModelNumberOverlay}
										>
											<span
												className="close"
												onClick={() => this.hideModelNumberOverlay()}
											>
												&times;
											</span>

											<div className="model-serial-number">
												<span className="model-number">
													{modelNo}
													<span className="label">Model Number</span>
												</span>
												<span className="serial-number">
													{serialNo}
													<span className="label">Serial Number</span>
												</span>
											</div>
											{modelNumberList}


										</div>
									}
								</div>
							)
							: modelType === 'modelAndSerial' ?
								(
									<div>
										{seeMoreLink &&
											<a
												className="arrow-link learn"
												href={seeMoreLinkImage}
												target="_blank"
											>
												{seeMoreLink.text}
											</a>
										}
										<div className="model-serial-toggle">
											<div className="row">
												<div className="col xs-6">
													<a
														onClick={() => this.selectModel()}
														className={classnames({
															selected: this.state.selected === 'model'
														})}
													>
														Model Number
													</a>
												</div>
												<div className="col xs-6">
													<a
														onClick={() => this.selectSerial()}
														className={
															classnames({
																selected: this.state.selected === 'serial'
															})}
													>
														Serial Number
													</a>
												</div>
											</div>
										</div>
									</div>
								)
								:
								(
									<div className="chest-file">
										<a
											className="arrow-link learn"
											href="https://cdn.masterlock.com/sentrysafe/resources/pdf/SentrySafe-Model-Code.pdf"
											target="_blank"
										>
											Click here to learn more
										</a>
										<div className="model-serial-toggle">
											<div className="row">
												<div className="col xs-6">
													<a
														onClick={() => this.selectModel()}
														className={classnames({
															selected: this.state.selected === 'model'
														})}
													>
														Model Number
													</a>
												</div>
												<div className="col xs-6">
													<a
														onClick={() => this.selectSerial()}
														className={
															classnames({
																selected: this.state.selected === 'serial'
															})}
													>
														Serial Number
													</a>
												</div>
											</div>
										</div>
									</div>
								)
					}
				</div>
			</div>
		);
	}
}

export default ModelSerialCard;


// WEBPACK FOOTER //
// ./src/pages/support/findModelSerialNumber/ModelSerialCard.js